import React from 'react';
import { Link } from 'react-router-dom';
import type { PublicNavItem } from './publicNavBlueprint';

export const dropdownPanelClass =
  'invisible absolute left-0 top-full z-50 mt-2 w-52 rounded-lg border border-gray-200 bg-white p-2 opacity-0 shadow-xl transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100 dark:border-gray-700 dark:bg-boxdark';

export const dropdownLinkClass =
  'block rounded px-3 py-2 text-sm text-gray-800 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-800';

export const mobileNavLinkClass =
  '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-800';

export function NavDropdownLink({ item, onNavigate }: { item: PublicNavItem; onNavigate?: () => void }) {
  if (item.isExternalAnchor) {
    return (
      <a href={item.href} className={dropdownLinkClass} onClick={onNavigate}>
        {item.label}
      </a>
    );
  }
  return (
    <Link to={item.href} className={dropdownLinkClass} onClick={onNavigate}>
      {item.label}
    </Link>
  );
}

export function NavMobileLink({ item, onNavigate }: { item: PublicNavItem; onNavigate: () => void }) {
  if (item.isExternalAnchor) {
    return (
      <a href={item.href} className={mobileNavLinkClass} onClick={onNavigate}>
        {item.label}
      </a>
    );
  }
  return (
    <Link to={item.href} className={mobileNavLinkClass} onClick={onNavigate}>
      {item.label}
    </Link>
  );
}
